var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"checkout-input-school-address"},[_vm._m(0),_c('div',[_vm._v(" Your school order will be shipped to: "),_c('div',[_vm._v(_vm._s(_vm.schoolName))]),_c('div',[_vm._v(_vm._s(_vm.schoolAddress))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',[_c('h4',[_vm._v("Shipping Address")])])
}]

export { render, staticRenderFns }